import pushClevertapEvent from '../pushClevertapEvent';

/**
 * @param {array} pinSettings
 */
export function savePin({ pinSettings }) {
  const data = {};
  pinSettings.forEach((pin) => {
    data[pin.sub_menu] = pin.pin_required;
  });
  pushClevertapEvent('Configure PIN Access', data);
}
